/*
 * pa-nav-a11y.js — keyboard accessibility for the vintage-theme primary nav.
 * Progressive enhancement ONLY: the existing CSS :hover behavior is untouched.
 *
 * Uses EVENT DELEGATION (one document-level listener) rather than per-element
 * binding, because the theme builds its sticky header with cloneNode(true) —
 * which copies attributes but NOT listeners. Delegation covers the original nav,
 * the sticky clone, and any nav injected later, with no re-binding needed.
 *
 * For each dropdown parent (a[aria-haspopup="true"] in the nav):
 *   - aria-expanded reflects open/closed state
 *   - Enter / Space / ArrowDown  -> open submenu + move focus to first item
 *   - Escape (on parent or inside) -> close submenu + return focus to parent
 *   - click on an href="#" parent  -> open/close instead of jumping to top
 * WCAG 2.1.1 (Keyboard) + 4.1.2 (Name, Role, Value).
 */
(function () {
  var SEL = '.vertical-menu a[aria-haspopup="true"], .main_nav_wrapper a[aria-haspopup="true"]';

  function submenuFor(toggle) {
    var li = toggle.closest('li');
    if (!li) return null;
    return li.querySelector(':scope > .vertical-menu_submenu, :scope > .vertical-menu_sub-submenu') ||
           li.querySelector('.vertical-menu_submenu, .vertical-menu_sub-submenu');
  }
  function openMenu(toggle, sub, moveFocus) {
    sub.classList.add('is-visible');
    toggle.setAttribute('aria-expanded', 'true');
    if (moveFocus) { var first = sub.querySelector('a'); if (first) first.focus(); }
  }
  function closeMenu(toggle, sub) {
    sub.classList.remove('is-visible');
    toggle.setAttribute('aria-expanded', 'false');
  }

  // Tracks the toggle just handled by a keydown so the synthesized click that
  // follows keyboard activation of a link doesn't toggle it straight back.
  var suppressUntil = 0;

  document.addEventListener('keydown', function (e) {
    var toggle = e.target.closest && e.target.closest(SEL);

    if (toggle) {
      var sub = submenuFor(toggle);
      if (!sub) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'ArrowDown') {
        e.preventDefault();
        suppressUntil = Date.now() + 400;
        openMenu(toggle, sub, true);
      } else if (e.key === 'Escape') {
        closeMenu(toggle, sub);
      }
      return;
    }

    // Escape while focus is INSIDE an open submenu: close it, return focus to parent.
    if (e.key === 'Escape') {
      var openSub = e.target.closest && e.target.closest('.vertical-menu_submenu.is-visible, .vertical-menu_sub-submenu.is-visible');
      if (openSub) {
        var li = openSub.closest('li');
        var parentToggle = li && li.querySelector(SEL);
        if (parentToggle) { closeMenu(parentToggle, openSub); parentToggle.focus(); }
      }
    }
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest(SEL);
    if (!toggle) return;
    if (Date.now() < suppressUntil) { e.preventDefault(); return; } // swallow post-keydown click
    if (toggle.getAttribute('href') === '#') {
      var sub = submenuFor(toggle);
      if (!sub) return;
      e.preventDefault();
      sub.classList.contains('is-visible') ? closeMenu(toggle, sub) : openMenu(toggle, sub, true);
    }
  }, true); // capture, so we beat the theme's own click-to-top behavior

  // Close when focus leaves the whole menu item (delegated via focusout bubbling).
  document.addEventListener('focusout', function (e) {
    var li = e.target.closest && e.target.closest('li');
    if (!li) return;
    var toggle = li.querySelector(SEL);
    var sub = toggle && submenuFor(toggle);
    if (toggle && sub && sub.classList.contains('is-visible') && !li.contains(e.relatedTarget)) {
      closeMenu(toggle, sub);
    }
  });

  // Initial state: announce every dropdown parent as collapsed. Re-runs on DOM
  // changes so the sticky-nav clone (added after load) is covered too.
  function markCollapsed() {
    var toggles = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(toggles, function (t) {
      if (!t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false');
    });
  }

  // The theme's Headhesive sticky-nav clone (.main_nav_wrapper.sticky_nav) is
  // prepended to <body> and parked off-screen while still keyboard-focusable —
  // so it steals the first tab stops ahead of the skip link and duplicates the
  // nav for keyboard users. Make it `inert` whenever it isn't 'stuck' (visible),
  // and restore it the moment Headhesive pins it. `inert` removes it from BOTH
  // the tab order and the a11y tree, so no aria-hidden-focus pitfall.
  var cloneObserved = false;
  function syncClone() {
    var clone = document.querySelector('.main_nav_wrapper.sticky_nav');
    if (!clone) return;
    if (clone.classList.contains('sticky_nav--stick')) clone.removeAttribute('inert');
    else clone.setAttribute('inert', '');
  }
  function watchClone() {
    var clone = document.querySelector('.main_nav_wrapper.sticky_nav');
    if (clone && !cloneObserved) {
      cloneObserved = true;
      try { new MutationObserver(syncClone).observe(clone, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    }
    syncClone();
  }

  function init() {
    markCollapsed();
    watchClone();
    try {
      new MutationObserver(function () { markCollapsed(); watchClone(); }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
